

//end preload image
(function ($) {
    var container;
    var body = document.body;
    var html = document.documentElement;
    var isRevert = false;
    var blockLeft, blockRight;

    var uploadUrl = $('#uploadsurl').data('value');

    $(document).ready(function(){
        removeSpacebar();
    });

    window.onresize = function(e){
        removeSpacebar();
    };

    // Select container more than one article
    container = $('[data-count="2"], [data-count="3"], [data-count="4"], [data-count="5"]');

    if (container.length <= 0)
        return false;

    container.each(function (index, el) {
        var $el = $(el);
        var article = $el.find('.text-article');
        article.addClass('cursor');

        // First time, set first article to active
        // $(article[1]).addClass('active');

        article.on('mouseover', function (e) {
                var that = $(this);

                // If article has active, return
                if (that.hasClass('active'))
                    return;

                // Remove current article active
                var parent = that.closest('[data-count]');
                parent.find('.text-article.active').removeClass('active');
                

                // Set current article to active
                that.addClass('active');

                //change image when change image sub background
                var subBackground = $('.sub-background');
                subBackground.each(function(index, el){
                    el.style.display = 'none';
                });
                
                if(body.clientWidth > 768){
                    if(that[0] && that[0].id && subBackground.length > 1){
                        $('#sub-background-'+that[0].id).css('display', 'block');
                    }
                }
        });

        article.on('mouseleave', function (e) {
            $(article).removeClass('active');
            // $(article[1]).addClass('active');
        });
    });

    var articleContent = $('.text-article-content p a');
    articleContent.each(function(index, el){
        if(el.text.trim() == 'READ MORE'){
            var chevronRightHTML = '<span style="position: absolute;right: 5%;">';

            chevronRightHTML += '<img src="'+uploadUrl+'/arrow-right.png" />';
            chevronRightHTML +=  '</span>';
            $(chevronRightHTML).appendTo(articleContent[index]);
        }
    });
    function removeSpacebar(){
        var bodyWidth = Math.min(body.offsetWidth, html.clientWidth, html.offsetWidth, body.clientHeight, html.clientHeight);
        if(bodyWidth <= 768){
            var elements = $('.text-article-content p');
            elements.each(function(index, el){
                if(el.innerHTML == '' || el.innerHTML == '&nbsp;'){
                    el.style.fontSize  = '1vh';
                }
            });
        }
    }

    $('#our-business-page .block-container .rock-block-left').on('mouseover', function(){
        $('#our-business-page .slider-left-background').css('color', '#292929');
    });
    $('#our-business-page .block-container .rock-block-left').on('mouseover', function(){
        $('#our-business-page .slider-left-background .slider-content').css('color', '#292929');
    });
    $('#our-business-page .block-container .rock-block-left').on('mouseover', function(){
        $('#our-business-page .slider-left-background .slider-content hr').css('border-top-color', '#292929');
    });
    $('#our-business-page .block-container .rock-block-left').on('mouseleave', function(){
        $('#our-business-page .slider-left-background').css('color', '#fff');
    });
    $('#our-business-page .block-container .rock-block-left').on('mouseleave', function(){
        $('#our-business-page .slider-left-background .slider-content').css('color', '#fff');
    });
    $('#our-business-page .block-container .rock-block-left').on('mouseleave', function(){
        $('#our-business-page .slider-left-background .slider-content hr').css('border-top-color', '#fff');
    });





})(jQuery);